export default __webpack_public_path__ + "static/media/arrow.88f70f4f.svg";